import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {articlePicker_template} from "../components/templates/articlePicker_template";
import {vignettePicker_template} from "../components/templates/vignettePicker_template";
import {UploadStatusHandler} from "../utils/UploadStatusHandler";
import {HYPERLINK_DATA_FIELDS} from "../utils/consts/hyperlink_data_fields";

declare var ko: any;

export class vignettePicker_helper {

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected vignettePicker: vignettePicker_template;
    protected articlePicker: articlePicker_template;
    private vnAppZone: any;
    private callerModule: any;
    public validationTemplate: any;
    public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    private static readonly articleCompleted: number = 6;
    // Guard id to cancel/ignore stale hub URL validations
    private hubUrlValidationId: number = 0;
    private tagInsertContext: {
        tagId: number | null;
        variables: Array<{ name: string; value: string }>;
    } | null = null;
    private tagInsertContextCallback: (() => void) | null = null;

    constructor(vignettePicker: vignettePicker_template, vnAppZone: any, callerModule: any) {
        this.vignettePicker = vignettePicker;
        this.vnAppZone = vnAppZone;
        this.callerModule = callerModule;
        this.validationTemplate = callerModule.validationTemplate;
    }

    public getVnAppZone(): any {
        return this.vnAppZone;
    }

    public manageResponse(req, obj, callback): void {
        this.callerModule.manageResponse(req, this.callerModule, callback);
    }

    public insertImage(image, target, extra_option = null): void {
        this.vignettePicker.vignettePickerInsertForm_template.applyImageSpecs(image);
    }

    protected getVignetteReferences() {


        if (typeof this.callerModule.getVignetteReferences === 'function') {
            return;
        }

        if (this.XHRHdls['getVignetteReferences']) {

            this.XHRHdls['getVignetteReferences'].cancelAndReset();
        }
        let usrReq_url: string = '/api/brands/get/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['getVignetteReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getVignetteReferences'].onReadyStateFunction = this.onReferenceRequestReturn;
        this.XHRHdls['getVignetteReferences'].execute();
    }

    protected onReferenceRequestReturn(req, obj) {
        return function () {

            if (!obj.callerModule || typeof obj.callerModule.manageResponse !== 'function') {
                console.warn('Error: callerModule is undefined or manageResponse is not a function.');
                return;
            }

            try {
                obj.callerModule.manageResponse(req, obj.callerModule, function () {
                    try {
                        const responseParsed = JSON.parse(req.request.response);
                        obj.vignettePicker.setOwnerBrandFilterItems(responseParsed);
                    } catch (error) {
                        console.error('Error parsing response:', error);
                    }
                });
            } catch (error) {
                console.warn('Error calling manageResponse:', error);
            }
        };
    }

    protected getVignetteList() {

        // LOADING : starts
        this.vignettePicker.showLoading();

        if (this.XHRHdls['getVignetteList']) {

            this.XHRHdls['getVignetteList'].cancelAndReset();
        }
        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }
        let usrReq_url: string = `/api/brand/${brand}/tags/vignettes/get/`;
        let vm = this.vignettePicker.getViewModelForRequest();
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(vm)]);
        usrReq_params.push(['isVignettePickerRequest', 'true']);

        this.XHRHdls['getVignetteList'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getVignetteList'].onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdls['getVignetteList'].execute();
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.vignettePicker.hideLoading();
            });
        }
    }

    protected updateList(responseParsed: any) {

        this.vignettePicker.setVignettePagination(responseParsed.totalPage, responseParsed.currentPage);
        this.vignettePicker.setVignettes(responseParsed.data);
    }

    protected filterMultipleSelectorOnChange() {
        this.vignettePicker.resetPagination();
        this.getVignetteList();
    }

    protected filterSimpleCancel() {

    }

    //===============================================
    public cancelTagFilterRequests() {
        try {
            const sugg = this.XHRHdls['getTagsSuggestion'];
            if (sugg && typeof sugg.cancelAndReset === 'function') {
                sugg.cancelAndReset();
            }
        } catch (e) {
            console.error('Error cancelling previous tag filter request:', e);
        }

        try {
            const prev = this.XHRHdls['getPreviewTagSpecs_forInsertForm'];
            if (prev && typeof prev.cancelAndReset === 'function') {
                prev.cancelAndReset();
            }
        } catch (e) {
            console.error('Error cancelling previous tag preview request:', e);
        }

        // Invalidate any in-flight hub URL validations
        this.hubUrlValidationId++;
        this.tagInsertContext = null;
        this.tagInsertContextCallback = null;

        try {
            const ctxReq = this.XHRHdls['getTagInsertContext'];
            if (ctxReq && typeof ctxReq.cancelAndReset === 'function') {
                ctxReq.cancelAndReset();
            }
        } catch (e) {
            console.error('Error cancelling tag insert context request:', e);
        }

        // Also reset loading indicator on the form
        try {
            const vm = this.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
            if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
        } catch (e) {
            console.error('Error resetting loading indicator on the form:', e);
        }
    }

    protected getVignetteById(id) {

        if (this.XHRHdls['getVignetteById']) {

            this.XHRHdls['getVignetteById'].cancelAndReset();
        }

        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }

        let usrReq_url: string = '/api/brand/' + brand + '/tags/vignettes/get/' + id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['isVignettePickerRequest', 'true']);

        this.XHRHdls['getVignetteById'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getVignetteById'].onReadyStateFunction = this.onByIdRequestReturn;
        this.XHRHdls['getVignetteById'].execute();
    }

    protected onByIdRequestReturn(req, obj) {

        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setVignetteData(responseParsed.data.vignette);
            })
        }
    }

    protected setVignetteData(vignette) {
        this.vignettePicker.vignettePickerInsertForm_template.setVignetteData(vignette);
        this.initializeBrandReferences();
        this.setListingPageAutocomplete();
        this.setAuthorAutocomplete();
    }

    protected setAuthorAutocomplete(): void {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        const vm = form.getTemplateViewModel();
        const references = vm && typeof vm.references === 'function' ? vm.references() : null;
        const authors = references && Array.isArray(references.authors) ? references.authors : [];
        const authorReference = authors.filter((item) => item && item.id)[0];

        if (authorReference) {
            form.setSelectedAuthor({
                id: authorReference.id,
                name: authorReference.name || `Author ${authorReference.id}`
            });
        }
    }

    protected setListingPageAutocomplete(): void {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        const vm = form.getTemplateViewModel();
        const references = vm && typeof vm.references === 'function' ? vm.references() : null;
        const listingPages = references && Array.isArray(references.listingPages) ? references.listingPages : [];
        const listingPageReference = listingPages.filter((item) => item && item.id)[0];

        if (listingPageReference) {
            form.setSelectedListingPage({
                id: listingPageReference.id,
                name: listingPageReference.name || listingPageReference.permalink || `Listing Page ${listingPageReference.id}`,
                permalink: listingPageReference.permalink || ''
            });
            this.vignettePicker.hideFullLoading();
            form.hideLoading();
        }else{
            this.vignettePicker.vignettePickerInsertForm_template.clearListingPageFilterInput();
            this.vignettePicker.hideFullLoading();
            this.vignettePicker.vignettePickerInsertForm_template.hideLoading();
        }
    }

    protected getSelectedInsertTagId() {
        try {
            if (this.vignettePicker && this.vignettePicker.vignettePickerInsertForm_template &&
                typeof this.vignettePicker.vignettePickerInsertForm_template.getSelectedTagId === 'function') {
                return this.vignettePicker.vignettePickerInsertForm_template.getSelectedTagId();
            }
        } catch (e) {
            // ignore
        }
        return null;
    }

    protected insertVignetteDisplayCardElement(elementToReplace, vignetteObject) {
        var self = this;
        var doInsert = function () {
            var vignetteElement = self.buildVignetteDisplayCardElement(vignetteObject);
            self.callerModule.insertVignetteElement(elementToReplace, vignetteElement, self.vignettePicker.getTarget());
            self.vignettePicker.vignettePickerInsertForm_template.hide();
            self.vignettePicker.hide();
        };

        var selectedTagId = this.getSelectedInsertTagId();
        if (selectedTagId == null || selectedTagId === "") {
            doInsert();
            return;
        }

        var cachedContext = this.tagInsertContext;
        if (cachedContext && cachedContext.tagId == selectedTagId) {
            doInsert();
            return;
        }

        this.fetchTagInsertContext(selectedTagId, doInsert);
    }

    protected buildVignetteDisplayCardElement(vignette) {
        // ---- safe pulls ----
        var id = (vignette && vignette.id != null) ? vignette.id : "";
        var html = (vignette && vignette.html != null) ? vignette.html : "";
        var css = (vignette && vignette.css != null) ? vignette.css : "";
        var js = (vignette && vignette.js != null) ? vignette.js : "";
        var isDynamicPlacement = !!(vignette && vignette.isDynamicPlacement);
        var varsIn = vignette ? vignette.variables : null;
        var referencesIn = vignette ? vignette.references : null;

        // ---- helpers ----
        function escapeAttrSingle(s) {
            return String(s)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/'/g, "&#39;")
                .replace(/"/g, "&quot;");
        }

        function stripScripts(raw) {
            var tmp = document.createElement("div");
            tmp.innerHTML = String(raw);
            var scripts = tmp.getElementsByTagName("script"); // live NodeList
            while (scripts.length) {
                var s = scripts[0];
                if (s.parentNode) s.parentNode.removeChild(s);
            }
            return tmp.innerHTML;
        }

        function minifyHtml(s) {
            s = String(s);
            s = s.replace(/\r?\n/g, " ");       // kill CR/LF
            s = s.replace(/\s+/g, " ");         // collapse whitespace
            s = s.replace(/>\s+</g, "><");      // trim between tags
            return s.trim();
        }

        function minifyCss(s) {
            s = String(s);
            s = s.replace(/\/\*[\s\S]*?\*\//g, ""); // strip /* comments */
            s = s.replace(/\s+/g, " ");             // collapse whitespace
            s = s.replace(/\s*([{}:;,>])\s*/g, "$1");// trim around punctuation
            s = s.replace(/;}/g, "}");              // drop trailing ;
            return s.trim();
        }

        function minifyJs(s) {
            s = String(s);
            s = s.replace(/\/\*[\s\S]*?\*\//g, ""); // block comments
            s = s.replace(/\/\/[^\n\r]*/g, "");     // line comments
            s = s.replace(/\s+/g, " ");             // collapse whitespace
            return s.trim();
        }

        function isFn(v) {
            return typeof v === "function";
        }

        function safeCall(fn) {
            try {
                return fn();
            } catch (_) {
                return "";
            }
        }

        function unwrap(v) {
            return isFn(v) ? safeCall(v) : v;
        }

        // ---- main ----

        // 1) sanitize source HTML (remove <script> blocks)
        var safeHtml = stripScripts(html);

        // 2) normalize variables -> [{name, value}]
        var varsArray = [];
        if (Array.isArray(varsIn)) {
            varsArray = varsIn;
        } else if (varsIn && typeof varsIn === "object" && !isFn(varsIn)) {
            for (var k in varsIn) if (Object.prototype.hasOwnProperty.call(varsIn, k)) {
                varsArray.push({name: k, value: varsIn[k]});
            }
        } else if (isFn(varsIn)) {
            var tmp = safeCall(varsIn);
            if (Array.isArray(tmp)) varsArray = tmp;
        }
        var resolvedVars = varsArray.map(function (it) {
            var name = (it && (it.name || it.key || it.variable)) || "";
            var value = it ? unwrap(it.value) : "";
            return {name: String(name), value: value};
        }).filter(function (v) {
            return v.name.length > 0;
        });

        // 3) replace [[TOKEN]] (exact, case-sensitive)
        var valueMap = Object.create(null);
        for (var i = 0; i < resolvedVars.length; i++) valueMap[resolvedVars[i].name] = resolvedVars[i].value;

        function fillPlaceholders(content) {
            return String(content || '').replace(/\[\[\s*([^\]\[]+?)\s*\]\]/g, function (full, keyRaw) {
                var key = String(keyRaw).trim();
                if (Object.prototype.hasOwnProperty.call(valueMap, key)) {
                    var v = valueMap[key];
                    return (v == null) ? "" : String(v);
                }
                return full;
            });
        }

        var filledHtml = fillPlaceholders(safeHtml);

        // 4) MINIFY HTML & CSS
        var filledHtmlMin = minifyHtml(filledHtml);
        var filledCss = fillPlaceholders(css);
        var cssBlock = filledCss ? minifyCss("<style>" + filledCss + "</style>") : "";
        var jsBlock = js ? minifyJs(js) : "";

        // 5) Pull the tag id and include it in variables metadata.
        // The insert context is fetched from the selected tag id (it's what produces
        // model_year_tag_id/owner_url_hub_page), so its tagId is the reliable source.
        var resolvedTagId = this.getSelectedInsertTagId();
        if (resolvedTagId == null || resolvedTagId === "") {
            resolvedTagId = this.tagInsertContext && this.tagInsertContext.tagId != null
                ? this.tagInsertContext.tagId
                : null;
        }
        if (resolvedTagId != null && resolvedTagId !== "") {
            var tagIdValue = String(resolvedTagId);
            var existingTagIdVar = null;
            for (var ti = 0; ti < resolvedVars.length; ti++) {
                if (resolvedVars[ti] && resolvedVars[ti].name === "tag_id") {
                    existingTagIdVar = resolvedVars[ti];
                    break;
                }
            }
            if (!existingTagIdVar) {
                resolvedVars.push({ name: "tag_id", value: tagIdValue });
            } else if (existingTagIdVar.value == null || existingTagIdVar.value === "") {
                existingTagIdVar.value = tagIdValue;
            }
        }

        var extraInsertVariables = this.tagInsertContext ? this.tagInsertContext.variables : [];
        if (Array.isArray(extraInsertVariables)) {
            extraInsertVariables.forEach(function (variable) {
                if (!variable || !variable.name) {
                    return;
                }
                resolvedVars.push({
                    name: String(variable.name),
                    value: variable.value == null ? "" : String(variable.value),
                });
            });
        }

        // 6) Variables JSON
        var dataVarsJson = JSON.stringify(resolvedVars);
        var referencesJson = JSON.stringify(referencesIn || { articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [] });

        // 6) Build attributes (single-quoted for readability of JSON)
        var a_id = (id !== "") ? " data-id='" + escapeAttrSingle(String(id)) + "'" : "";
        var a_variables = " data-variables='" + escapeAttrSingle(dataVarsJson) + "'";
        var a_references = " data-references='" + escapeAttrSingle(referencesJson) + "'";
        var a_dynamicPlacement = ' data-dynamic-placement="' + (isDynamicPlacement ? "1" : "0") + '"';

        // 7) Final card
        return '<div class="emaki-displayCard vignette" contenteditable="false"'
            + a_variables + a_references + a_id + a_dynamicPlacement + '>'
            + cssBlock
            + filledHtmlMin
            + '</div>'
            + jsBlock;
    }

    protected filterSimpleOnChange(idElement) {
        // When used inside the insert form's embedded tag filter, fetch and apply tag specs
        if (idElement === 'insertFormTagFilter') {
            this.updateInsertFormTagSelectedValue();
            return;
        }
        if (idElement === 'insertFormArticleFilter') {
            this.updateInsertFormArticleSelectedValue(idElement);
            return;
        }
        if (idElement === 'insertFormListingPageFilter') {
            this.updateInsertFormListingPageSelectedValue();
            return;
        }
        if (idElement === 'insertFormHubPageFilter') {
            this.updateInsertFormHubPageSelectedValue();
            return;
        }
        if (idElement === 'insertFormVideoFilter') {
            this.updateInsertFormVideoSelectedValue(idElement);
            return;
        }
        if (idElement === 'insertFormAuthorFilter') {
            this.updateInsertFormAuthorSelectedValue();
            return;
        }
        this.vignettePicker.resetPagination();
        this.getVignetteList();
    }

    //===============================================
    //tag autocomplete and preview tag functions
    protected getTagsSuggestion(keyword, idElement) {

        if (this.XHRHdls["getTagsSuggestion"]) {
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        const subViewModel = {filter: {keyword: keyword, getNonSelectable: true}, idElement: idElement};
        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }
        const usrReq_url: string = `/api/brand/${brand}/search/tag/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls['getTagsSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {

                const responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data && responseParsed.data.tags) {
                    const tags = responseParsed.data.tags.map(tag => {
                        tag.isSelectable = !!tag.isSelectable;
                        return tag;
                    });
                    // Route suggestions to the insert form's tag filter
                    obj.vignettePicker.vignettePickerInsertForm_template.setTagFilter(tags);
                }
            });
        }
    }

    protected updateInsertFormTagSelectedValue() {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        const vm = form.getTemplateViewModel();
        const selectedTags = form.getSelectedTags();
        const tagNeedingFetch = selectedTags.filter((tag) => tag && tag.id && !tag.isPreviewDataLoaded)[0];

        if (tagNeedingFetch) {
            if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(true);
            if (vm && typeof vm.specsFillMessage === 'function') vm.specsFillMessage("");
            this.getPreviewTag(tagNeedingFetch.id);
            return;
        }

        form.applyTagsSpecs(selectedTags);
        if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
    }

    protected getPreviewTag(idTag) {
        // No tag selected: clear message and return
        if (!idTag) {
            this.tagInsertContext = null;
            const form = this.vignettePicker.vignettePickerInsertForm_template;
            if (form && form.getTemplateViewModel && typeof form.getTemplateViewModel === 'function') {
                const vm = form.getTemplateViewModel();
                if (vm && typeof vm.specsLoading === 'function') {
                    vm.specsLoading(false);
                }
                if (vm && typeof vm.specsFillMessage === 'function') {
                    vm.specsFillMessage("");
                }
            }
            form.applyTagsSpecs([]);
            return;
        }

        const idRequest: string = 'getPreviewTagSpecs_forInsertForm';
        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }

        if (this.XHRHdls[idRequest]) {
            this.XHRHdls[idRequest].cancelAndReset();
        }


        try {
            const vm = this.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
            if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(true);
            if (vm && typeof vm.specsFillMessage === 'function') vm.specsFillMessage("");
        } catch (e) {
            /* noop */
        }

        const url: string = `/api/brand/${brand}/tags/get/${idTag}`;
        const params: string[][] = [];
        this.XHRHdls[idRequest] = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdls[idRequest].onReadyStateFunction = this.onGetPreviewTagReturn;
        this.XHRHdls[idRequest].execute();
        this.fetchTagInsertContext(idTag);
    }

    protected fetchTagInsertContext(idTag: string | number | null | undefined, callback?: () => void) {
        this.tagInsertContext = null;
        this.tagInsertContextCallback = typeof callback === 'function' ? callback : null;
        if (idTag == null || idTag === "") {
            this.runTagInsertContextCallback();
            return;
        }

        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }

        const requestKey = 'getTagInsertContext';
        if (this.XHRHdls[requestKey]) {
            this.XHRHdls[requestKey].cancelAndReset();
        }

        const url: string = `/api/brand/${brand}/tags/vignettes/insert-context/${idTag}/`;
        const params: string[][] = [];
        this.XHRHdls[requestKey] = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdls[requestKey].onReadyStateFunction = this.onTagInsertContextReturn;
        this.XHRHdls[requestKey].execute();
    }

    protected runTagInsertContextCallback() {
        var callback = this.tagInsertContextCallback;
        this.tagInsertContextCallback = null;
        if (typeof callback === 'function') {
            callback();
        }
    }

    protected onTagInsertContextReturn(req, obj) {
        return () => {
            obj.callerModule.manageResponse(req, obj.callerModule, () => {
                try {
                    const responseParsed = JSON.parse(req.request.response);
                    const variables = Array.isArray(responseParsed.variables) ? responseParsed.variables : [];
                    obj.tagInsertContext = {
                        tagId: responseParsed.tagId != null ? responseParsed.tagId : null,
                        variables: variables
                            .filter((variable) => variable && variable.name)
                            .map((variable) => ({
                                name: String(variable.name),
                                value: variable.value == null ? "" : String(variable.value),
                            })),
                    };
                } catch (e) {
                    obj.tagInsertContext = null;
                }
                obj.runTagInsertContextCallback();
            });
        };
    }

    protected onGetPreviewTagReturn(req, obj) {
        return () => {
            obj.callerModule.manageResponse(req, obj.callerModule, () => {
                const responseParsed = JSON.parse(req.request.response);
                const tag = responseParsed.tag;
                const specsValues = responseParsed.specsValues;
                const specDefaults = responseParsed.specDefaults;

                const vm = obj.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
                if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(true);


                let tagsFilter: any[] = [];
                try {
                    const insertTpl: any = obj.vignettePicker && (obj.vignettePicker as any).vignettePickerInsertForm_template;
                    const tagFilter = insertTpl && insertTpl["tagFilter"];
                    if (tagFilter && typeof tagFilter.getTagsForRequest === 'function') {
                        const arr = tagFilter.getTagsForRequest();
                        if (Array.isArray(arr) && arr.length) {
                            tagsFilter = arr;
                        }
                    }
                } catch (e) { /* do nothing */ }

                // Fallback: if UI selection is empty, use the fetched tag itself
                if ((!tagsFilter || !tagsFilter.length) && tag && tag.id) {
                    tagsFilter = [{ id: tag.id, name: tag.name }];
                }

                obj.getListingPageByTag(tagsFilter, (page: any | null) => {
                    const defaultHubPageUrl = page && typeof page.permalink === 'string' ? page.permalink : '';

                    const form = obj.vignettePicker.vignettePickerInsertForm_template;
                    const selectedTags = form.getSelectedTags().map((selectedTag) => {
                        if (selectedTag.id == tag.id) {
                            tag.previewSpecValues = specsValues || [];
                            tag.previewSpecDefaults = specDefaults || [];
                            tag.previewExtraDefaults = { default_hub_page_url: defaultHubPageUrl };
                            tag.isPreviewDataLoaded = true;
                            return tag;
                        }
                        return selectedTag;
                    });
                    form.setSelectedTags(selectedTags);

                    const nextTagNeedingFetch = selectedTags.filter((selectedTag) => {
                        return selectedTag && selectedTag.id && !selectedTag.isPreviewDataLoaded;
                    })[0];

                    if (nextTagNeedingFetch) {
                        obj.getPreviewTag(nextTagNeedingFetch.id);
                    } else {
                        form.applyTagsSpecs(selectedTags);
                        if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
                    }
                });
            });

        };
    }

    protected getListingPageByTag(tagsFilter: any[] | null, callback: (item: any | null) => void) {
        try {
            let brand = this.vnAppZone.app.params.idBrand;
            if (!brand) {
                brand = this.callerModule.getBrandId();
            }

            // Choose tag id: prefer first from UI filter; else none
            let tagId: any = null;
            if (Array.isArray(tagsFilter) && tagsFilter.length && tagsFilter[0] && tagsFilter[0].id != null) {
                tagId = tagsFilter[0].id;
            }
            if (tagId == null) {
                if (typeof callback === 'function') callback(null);
                return;
            }

            const url: string = `/api/brand/${brand}/config/listing-pages/by-tag/${tagId}/`;
            const params: string[][] = [];
            const key = 'getListingPageByTag';
            if (this.XHRHdls[key]) {
                this.XHRHdls[key].cancelAndReset();
            }
            this.XHRHdls[key] = new XMLHttpRequestHandler(url, params, this);
            this.XHRHdls[key].onReadyStateFunction = (req, obj) => () => {
                obj.callerModule.manageResponse(req, obj.callerModule, () => {
                    try {
                        const res = JSON.parse(req.request.response);
                        const item = res && res.data ? res.data : null;
                        if (typeof callback === 'function') callback(item);
                    } catch (e) {
                        if (typeof callback === 'function') callback(null);
                    }
                });
            };
            this.XHRHdls[key].execute();
        } catch (e) {
            if (typeof callback === 'function') callback(null);
        }
    }

    //===============================================
    //article autocomplete and preview article functions
    public getArticlesSuggestion(keyword, idElement) {
        if (this.XHRHdls["getArticlesSuggestion"]) {
            this.XHRHdls["getArticlesSuggestion"].cancelAndReset();
        }
        const subViewModel = { list: { keyword: keyword }, limit: 100, idElement: idElement };
        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }
        
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/search/article/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls['getArticlesSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getArticlesSuggestion'].onReadyStateFunction = this.onGetArticlesSuggestionReturn;
        this.XHRHdls['getArticlesSuggestion'].execute();
    }

    protected onGetArticlesSuggestionReturn(req, obj) {
        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.vignettePicker.vignettePickerInsertForm_template.setArticleFilter(responseParsed.data.articles);
            });
        }
    }

    public updateInsertFormArticleSelectedValue(idElement) {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        const vm = form.getTemplateViewModel();
        const selectedArticles = form.getSelectedArticles();
        const articleNeedingFetch = selectedArticles.filter((article) => {
            return article && article.id && (!article.permalink || !article.contentType);
        })[0];

        if (articleNeedingFetch) {
            this.getPreviewArticle(articleNeedingFetch.id, idElement);
            return;
        }

        form.applyArticlesSpecs(selectedArticles);
        if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
    }

    public getPreviewArticle(idArticle, idElement) {
        const vm = this.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
        if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(true);

        if (this.XHRHdls["getPreviewArticle"]) {
            this.XHRHdls["getPreviewArticle"].cancelAndReset();
        }

        const subViewModel = { id: idArticle, idElement: idElement };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/articles/get/${idArticle}`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls["getPreviewArticle"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getPreviewArticle"].onReadyStateFunction = this.onGetPreviewArticleReturn;
        this.XHRHdls["getPreviewArticle"].execute();
    }

    protected onGetPreviewArticleReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }

            if (req.request.status !== 200) {
                // Keep session-expiry handling centralized, but never navigate away
                // from an article draft because a vignette preview cannot be loaded.
                if (req.request.status === 401) {
                    obj.callerModule.manageResponse(req, obj.callerModule, function () {});
                    return;
                }

                let message = "Unable to load the selected article.";
                try {
                    const responseParsed = JSON.parse(req.request.response);
                    message = responseParsed.message || message;
                } catch (e) {
                    // Use the fallback message for empty or non-JSON responses.
                }

                const vm = obj.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
                if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
                if (vm && typeof vm.specsFillMessage === 'function') vm.specsFillMessage(message);
                return;
            }

            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                const article = responseParsed.data.article && responseParsed.data.article.id ? responseParsed.data.article : null;
                const commentsCount = responseParsed.data.commentsCount ? responseParsed.data.commentsCount : 0;
                const displayAuthors = responseParsed.data.displayAuthors ? responseParsed.data.displayAuthors : [];
                const brandInfo = responseParsed.data.brandInfo ? responseParsed.data.brandInfo : null;

                const form = obj.vignettePicker.vignettePickerInsertForm_template;
                const selectedArticles = form.getSelectedArticles().map((selectedArticle) => {
                    if (article && selectedArticle.id == article.id) {
                        article.commentsCount = commentsCount;
                        article.displayAuthors = displayAuthors;
                        article.brandInfo = brandInfo;
                        return article;
                    }
                    return selectedArticle;
                });
                form.setSelectedArticles(selectedArticles);

                const nextArticleNeedingFetch = selectedArticles.filter((selectedArticle) => {
                    return selectedArticle && selectedArticle.id && (!selectedArticle.permalink || !selectedArticle.contentType);
                })[0];
                if (nextArticleNeedingFetch) {
                    obj.getPreviewArticle(nextArticleNeedingFetch.id, 'insertFormArticleFilter');
                    return;
                }

                form.applyArticlesSpecs(selectedArticles);
                const vm = obj.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
                if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
            });
        }
    }

    //===============================================
    //video autocomplete and preview video functions
    public getVideosSuggestion(keyword, idElement) {
        if (this.XHRHdls["getVideosSuggestion"]) {
            this.XHRHdls["getVideosSuggestion"].cancelAndReset();
        }

        const subViewModel = {
            filters: {
                keywords: keyword,
                ratio: null,
                orientation: null,
                tags: [],
                categories: [],
                contentTypes: [],
            },
            videoPagination: { pageNumber: 1, itemPerPage: 10 },
            orderBy: "dateCreated",
            orderByDirection: "DESC",
        };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/videos/get/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getVideosSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getVideosSuggestion"].onReadyStateFunction = this.onGetVideosSuggestionReturn;
        this.XHRHdls["getVideosSuggestion"].execute();
    }

    protected onGetVideosSuggestionReturn(req, obj) {
        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.vignettePicker.vignettePickerInsertForm_template.setVideoFilter(responseParsed.paginatedVideos.data || []);
            });
        }
    }

    public updateInsertFormVideoSelectedValue(idElement) {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        const vm = form.getTemplateViewModel();
        const selectedVideos = form.getSelectedVideos();
        const videoNeedingFetch = selectedVideos.filter((video) => {
            return video && video.id && !video.url;
        })[0];

        if (videoNeedingFetch) {
            this.getPreviewVideo(videoNeedingFetch.id, idElement);
            return;
        }

        form.applyVideosSpecs(selectedVideos);
        form.clearVideoFilterInput();
        if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
    }

    public getPreviewVideo(idVideo, idElement) {
        const vm = this.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
        if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(true);

        if (this.XHRHdls["getPreviewVideo"]) {
            this.XHRHdls["getPreviewVideo"].cancelAndReset();
        }

        const subViewModel = { id: idVideo, idElement: idElement };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/videos/get/${idVideo}`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getPreviewVideo"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getPreviewVideo"].onReadyStateFunction = this.onGetPreviewVideoReturn;
        this.XHRHdls["getPreviewVideo"].execute();
    }

    protected onGetPreviewVideoReturn(req, obj) {
        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                const video = responseParsed.data.video;
                const form = obj.vignettePicker.vignettePickerInsertForm_template;
                const selectedVideos = form.getSelectedVideos().map((selectedVideo) => {
                    if (video && selectedVideo.id == video.id) {
                        return video;
                    }
                    return selectedVideo;
                });
                form.setSelectedVideos(selectedVideos);

                const nextVideoNeedingFetch = selectedVideos.filter((selectedVideo) => {
                    return selectedVideo && selectedVideo.id && !selectedVideo.url;
                })[0];
                if (nextVideoNeedingFetch) {
                    obj.getPreviewVideo(nextVideoNeedingFetch.id, 'insertFormVideoFilter');
                    return;
                }

                form.applyVideosSpecs(selectedVideos);
                form.clearVideoFilterInput();
                const vm = obj.vignettePicker.vignettePickerInsertForm_template.getTemplateViewModel();
                if (vm && typeof vm.specsLoading === 'function') vm.specsLoading(false);
            });
        }
    }

    //===============================================
    //listing page autocomplete and insert-form article fill functions
    public getListingPagesSuggestion(keyword, idElement): void {
        if (this.XHRHdls["getListingPagesSuggestion"]) {
            this.XHRHdls["getListingPagesSuggestion"].cancelAndReset();
        }

        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }

        const filterData = { keyword: keyword };
        const subViewModel = { pagination: { itemPerPage: 50 }, filter: filterData, idElement: idElement };
        const usrReq_url: string = '/api/brand/' + brand + "/config/listing-pages/search/";
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);

        this.XHRHdls["getListingPagesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getListingPagesSuggestion"].onReadyStateFunction = this.onGetListingPagesSuggestionReturn.bind(this, idElement);
        this.XHRHdls["getListingPagesSuggestion"].execute();
    }

    protected onGetListingPagesSuggestionReturn(idElement, req, obj) {
        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.listingPages) {
                    if (idElement === 'insertFormHubPageFilter') {
                        obj.vignettePicker.vignettePickerInsertForm_template.setHubPageFilter(responseParsed.data.listingPages);
                    } else {
                        obj.vignettePicker.vignettePickerInsertForm_template.setListingPageFilter(responseParsed.data.listingPages);
                    }
                }
            });
        }
    }

    public getListingPageById(idListingPage, idElement): void {
        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }

        const key = 'getListingPageById_' + idElement;
        if (this.XHRHdls[key]) {
            this.XHRHdls[key].cancelAndReset();
        }

        const usrReq_url: string = `/api/brand/${brand}/config/listing-pages/get/${idListingPage}`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({ idElement: idElement })]);

        this.XHRHdls[key] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls[key].onReadyStateFunction = this.onGetListingPageByIdReturn;
        this.XHRHdls[key].execute();
    }

    protected onGetListingPageByIdReturn(req, obj) {
        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const response = JSON.parse(req.request.response);
                const listingPage = response.listingPage || (response.data && response.data.listingPage) || response.data;

                if (listingPage && listingPage.id) {
                    obj.vignettePicker.vignettePickerInsertForm_template.setSelectedListingPage(listingPage);
                    obj.vignettePicker.hideFullLoading();
                    obj.vignettePicker.vignettePickerInsertForm_template.hideLoading();
                }
            });
        }
    }

    public updateInsertFormListingPageSelectedValue() {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        form.applyListingPageSpecs(form.getSelectedListingPage());
    }

    public updateInsertFormHubPageSelectedValue() {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        form.applyHubPageSpecs(form.getSelectedHubPages());
    }

    //===============================================
    //author autocomplete functions
    public getUsersSuggestion(keyword, idElement) {
        if (this.XHRHdls["getUsersSuggestion"]) {
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }

        const subViewModel = { list: { keyword: keyword }, idElement: idElement };
        const usrReq_url: string = `/api/brand/${brand}/search/user/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls["getUsersSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getUsersSuggestion"].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls["getUsersSuggestion"].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {
        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.users) {
                    obj.vignettePicker.vignettePickerInsertForm_template.setAuthorFilter(responseParsed.data.users);
                }
            });
        }
    }

    public updateInsertFormAuthorSelectedValue() {
        const form = this.vignettePicker.vignettePickerInsertForm_template;
        form.applyAuthorSpecs(form.getSelectedAuthor());
    }

    //===============================================
    //brand references functions
    public initializeBrandReferences(): void {
        let brand = this.vnAppZone.app.params.idBrand;
        if (!brand) {
            brand = this.callerModule.getBrandId();
        }
        if (!brand) {
            return;
        }

        const url = `/api/brand/${brand}/tags/vignettes/references/`;

        if (this.XHRHdls['getBrandVignetteReferences']) {
            this.XHRHdls['getBrandVignetteReferences'].cancelAndReset();
        }

        this.XHRHdls['getBrandVignetteReferences'] = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdls['getBrandVignetteReferences'].onReadyStateFunction = this.onInitializeBrandReferencesReturn;
        this.XHRHdls['getBrandVignetteReferences'].execute();
    }

    public onInitializeBrandReferencesReturn(req, obj) {
        const helper: vignettePicker_helper = obj;

        return function () {
            if (!helper.callerModule || typeof helper.callerModule.manageResponse !== 'function') {
                return;
            }

            helper.callerModule.manageResponse(req, helper.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                const brandReferences = responseParsed.brand_references || {};
                const form = helper.vignettePicker.vignettePickerInsertForm_template;

                if (form && typeof form.setBrandReferences === 'function') {
                    form.setBrandReferences(brandReferences);
                }
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/vignettePicker_helper.ts